import React, { useCallback, useState } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";

const subTypes = ["TRIAL", "REGULAR"];

const SubscriptionTypeSelect = props => {
  const {
    onChange,
    disabled = false,
    required = false,
    value,
    label = "Subscription Type",
  } = props;

  const [selectedTypes, setSelectedTypes] = useState(value);

  const handleChange = useCallback(
    (_event, type) => {
      setSelectedTypes(type);
      onChange(type);
    },
    [onChange],
  );

  return (
    <Autocomplete
      id="subscription-type"
      disabled={disabled}
      options={subTypes}
      disableClearable={required}
      value={selectedTypes}
      onChange={handleChange}
      renderInput={params => (
        <TextField
          {...params}
          required={required}
          variant="standard"
          label={label}
          placeholder="Select..."
        />
      )}
    />
  );
};

export default SubscriptionTypeSelect;
